import apiFetch from '../apiFetch'

export default function (idOperario, token) {
  return apiFetch({endPoint: `Operario/deleteOperario`, method: 'POST', body: {idOperario}, token: token})
}
